import { EntityField } from '../../../../../@types/entity/field/crud/field-crud-entity';
import CreateFieldModalCrud from 'components/field/field-modal-component';
import { ModalCrud } from 'components/modal/modal-crud-component';
import { showErrorAlert, showSuccessAlert } from 'helper/show-alert-helper';
import { getEnv } from 'helper/window-helper';
import { UseAlert } from 'hook/alert-hook';
import { UseAuth } from 'hook/auth-hook';
import { useEffect, useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import { RestUseCase } from 'service/api/rest/rest-usecase';

interface PropsModalUpdateuserInfo {
  showModalUpdateuserInfo: boolean;
  closeModalUpdateuserInfo: () => void;
  openModalUpdateuserInfo: () => void;
  usuarioPrecisaAtualizarDados: boolean;
  updateUserInfoOnScreen: () => Promise<any>;
}

const entityFields: EntityField[] = [
  { name: "id", labelField: "", labelTable: "ID", typeField: "hidden", valueField: "", sizeField: 0, required: false, align: "left", tableField: { column: "id", columnVisible: true }, sort: true, filter: true },
  { name: "nomeEmpresa", labelField: "Empresa:", labelTable: "Empresa", valueField: "", typeField: "text", sizeField: 6, required: false, align: "left", tableField: { column: "Texto", columnVisible: false }, labelFieldDisable: true, filter: true, sort: true },
  { name: "cpf", labelField: "CPF:", labelTable: "CPF", typeField: "text", valueField: "", sizeField: 3, required: false, align: "center", tableField: { column: "Texto", columnVisible: true }, labelFieldDisable: false, filter: true, sort: true },
  { name: "nome", labelField: "Nome:", labelTable: "Nome", typeField: "text", valueField: "", sizeField: 6, required: false, align: "left", tableField: { column: "Texto", columnVisible: true }, labelFieldDisable: false, sort: true, filter: true },
  { name: "email", labelField: "Email:", labelTable: "Email", typeField: "text", valueField: "", sizeField: 6, required: false, align: "center", tableField: { column: "Texto", columnVisible: true }, labelFieldDisable: false, filter: true, sort: true },
];

export const ModalUpdateuserInfo: React.FC<PropsModalUpdateuserInfo> = ({ showModalUpdateuserInfo, closeModalUpdateuserInfo, openModalUpdateuserInfo, usuarioPrecisaAtualizarDados, updateUserInfoOnScreen }) => {
  
  const USER_ENDPOINT = getEnv("REACT_APP_END_POINT_USER")!
  
  const { loggedUserData } = UseAuth();
  const { showAlert } = UseAlert();

  const [entity, updateEntity] = useState(entityFields);
  const changeField = (modelFields: any) => {
    updateEntity(modelFields);
  };

  const onSubmitForm = async () => {
    updateUserInfo();
  };

  async function findUserById(id: number) {
    await new RestUseCase(`${USER_ENDPOINT}/user-info/${id}`).GetById().then((response) => {
      updateEntity(
        entityFields.map((value) => {
          value.valueField = response.body[value.name];
          return value;
        })
      );
    });
  }

  async function updateUserInfo(){
    let model: any = {}
    entity.forEach((value) => { model[value.name] = value.valueField })
    await new RestUseCase(USER_ENDPOINT + `/update-user-info/` + loggedUserData?.id).Patch({ data: model }).then((response) => {
        if (response.statusCode === 204) {
          showSuccessAlert(showAlert, 'Usuario salvo com sucesso')
        } else {
          showErrorAlert(showAlert, "Ops!!! Algo deu errado tente novamente mais tarde...");
        }
      })
    closeModalUpdateuserInfo();
    updateUserInfoOnScreen();
  }

  useEffect(() => {
    if(loggedUserData && showModalUpdateuserInfo){
      findUserById(loggedUserData?.id)  
    }
  }, [loggedUserData, showModalUpdateuserInfo]);

  return (
    <ModalCrud
      title={'Usuário'}
      open={openModalUpdateuserInfo}
      close={closeModalUpdateuserInfo}
      isOpen={showModalUpdateuserInfo}
      isEditing={true}
      submit={onSubmitForm}
    >
      <div>
        {usuarioPrecisaAtualizarDados && <Row>
          <h4 style={{color: 'red'}}>* É necessário validar seus dados</h4>
        </Row>
        }
        <CreateFieldModalCrud entityFields={entity} changeField={changeField} inEditing={true} />
      </div>
      <div>
        <Button variant="primary" size="sm" type="submit">
          Salvar
        </Button>
      </div>
    </ModalCrud>
  );
};
